export const UK_REDIRECTS = [
  { key: '/inside-kit', value: 'https://minuteful.com/uk/uti/', newTab: true },
  { key: '/faqs', value: 'https://minuteful.com/uk/uti/faqs', newTab: true },
  { key: '/contact-us', value: 'https://minuteful.com/uk/uti/', newTab: true },
  { key: '/info-center', value: '/info-center' },
  {
    key: '/terms-and-conditions',
    value: 'https://healthy.io/eu/apps/terms/',
    newTab: true,
  },
  {
    key: '/privacy-policy',
    value: 'https://minuteful.com/uk/uti/privacy',
    newTab: true,
  },
  {
    key: '/cookie-notice',
    value: 'https://healthy.io/eu/cookie-policy/',
    newTab: true,
  },
];

export const NHS_REDIRECTS = [
  {
    key: '/inside-kit',
    value: 'https://minuteful.com/uk/uti/nhs',
    newTab: true,
  },
  {
    key: '/faqs',
    value: 'https://minuteful.com/uk/uti/nhs/faqs',
    newTab: true,
  },
  {
    key: '/contact-us',
    value: 'https://minuteful.com/uk/uti/nhs',
    newTab: true,
  },
  { key: '/info-center', value: '/info-center' },
  {
    key: '/terms-and-conditions',
    value: 'https://healthy.io/eu/apps/terms/',
    newTab: true,
  },
  {
    key: '/privacy-policy',
    value: 'https://minuteful.com/uk/uti/privacy',
    newTab: true,
  },
  {
    key: '/cookie-notice',
    value: 'https://healthy.io/eu/cookie-policy/',
    newTab: true,
  },
];
